import React from 'react';

const Split = () => {
  return (
    <div>
      Not implemented yet. Visit{' '}
      <a href="https://github.com/AnimeAllstar/react-pdf-tools" target="_blank" rel="noreferrer">
        GitHub
      </a>{' '}
      to contribute.
    </div>
  );
};

export default Split;
